/*-----------------------------------
 * MP hayabusa Customize
 * [このファイルの役割]
 * ・プラグインの読み込み
 * ・URLによるモジュールの実行
 * ・サイト設定
 * ・URLによるCSS読み込み設定
 *-----------------------------------*/

import 'jquery.easing'
import './plugins/plugins'
import './plugins/utility'
import loader from './plugins/loader'
import INIT from './modules/init'

// ページ読み込み
import HOME from './page/home'
import PRODUCTS from './page/products'
import NEWS from './page/news'
import AGENCY from './page/agency'
import INQUIRY from './page/inquiry'

/*****
 * サイト設定
 */
window.siteinfo = {
  mapApiKeys: {
    'local':          'AIzaSyCTB3MSMYkTjSz6l30k79XflmmL_FcOxkg', //development
    'www.example.jp': '' //production
  }
}

// Webフォント読み込み
window.WebFontConfig = {
  google: {
    families: ['Kanit:300,400']
  },
  active: function () {
    sessionStorage.fonts = true;
  }
};

(function () {
  var wf = document.createElement('script');
  wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
  wf.type = 'text/javascript';
  wf.async = 'true';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(wf, s);
})();

/*****
 * サイト初期化
 */
INIT()
loader(( request, path ) => {
  switch( path ){
    case '/': HOME(); break
    case '/products/': PRODUCTS(); break
    case '/news/': NEWS(); break
    case '/agency/': AGENCY(); break
    case '/inquiry/': INQUIRY(); break
  }
  // switch( request ){}
})
